module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5LHKr"))).then(() => module.bundle.root('dJXJK'));